import { render } from "./MailVerifySigninTemplate.vue?vue&type=template&id=648b15fa"
import script from "./MailVerifySigninTemplate.vue?vue&type=script&lang=js"
export * from "./MailVerifySigninTemplate.vue?vue&type=script&lang=js"
script.render = render

export default script